// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a4M8Rs3yoK9lnjPg91Qj .iWLFMks6bBb5vjRyOeAG{height:44px;font-size:14px;font-weight:500;margin-top:40px}.a4M8Rs3yoK9lnjPg91Qj .P7jfu7KSHbsae94aZhn_{margin:24px 0}`, "",{"version":3,"sources":["webpack://./src/pages/auth/pages/reset/ui/ResetPassword/ui/ResetPasswordForm/styles.module.scss"],"names":[],"mappings":"AACE,4CACE,WAAA,CACA,cAAA,CACA,eAAA,CACA,eAAA,CAGF,4CACE,aAAA","sourcesContent":[".wrap {\n  .button {\n    height: 44px;\n    font-size: 14px;\n    font-weight: 500;\n    margin-top: 40px;\n  }\n\n  .alertError {\n    margin: 24px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `a4M8Rs3yoK9lnjPg91Qj`,
	"button": `iWLFMks6bBb5vjRyOeAG`,
	"alertError": `P7jfu7KSHbsae94aZhn_`
};
export default ___CSS_LOADER_EXPORT___;
